

import { Injectable } from '@angular/core';
import {
    CanActivate, Router,
    ActivatedRouteSnapshot,
    RouterStateSnapshot,
    CanLoad, Route
} from '@angular/router';

import { WorkflowService } from './../payment/workflow.service';

@Injectable()
export class SubscriptionWorkflowGuard implements CanActivate {
    constructor(private router: Router, private workflowService: WorkflowService) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): any {
        const path: string = route.routeConfig.path;
        return this.verifyWorkFlow(path);
    }

    verifyWorkFlow(path): boolean {
        // // If any of the previous steps is invalid, go back to the first invalid step
        const firstPath = this.workflowService.getFirstInvalidStep(path);
        if (firstPath.length > 0) {
            console.log('Redirected to ' + firstPath + ' path which it is the first invalid step.');
            const url = `/subscription/${firstPath}`;
            this.router.navigate([url]);
            return false;
        }
        return true;
    }
}
